<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h3>Logs</h3>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-divider></v-divider>
    <v-row>
      <v-col>
        <v-tabs background-color="primary" dark show-arrows>
          <v-tab>
            <v-icon left>mdi-card-bulleted-outline</v-icon>
            Infos
          </v-tab>

          <v-tab>
            <v-icon left>mdi-close-box-outline</v-icon>
            Erros
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-textarea background-color="black" label="Logs" :value="logs" rows="20" dark auto-focus filled></v-textarea>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-textarea background-color="black" label="Erros" :value="erros" rows="20" dark auto-focus filled></v-textarea>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  name: 'Integrations',
  data: () => ({
    logs: '',
    erros: '',
  }),
  methods: {
    loadLogs() {
      this.loading = true
      const url = `${baseApiUrl}/sandbox/readlog`
      axios
        .get(url)
        .then((res) => {
          this.logs = res.data.logs
          this.erros = res.data.erros
        })
        .catch(showError)
        .finally((this.loading = false))
    },
  },
  mounted() {
    this.loadLogs()
  },
}
</script>
